import { Package } from 'lucide-react';
import { useState } from 'react';

export function ProductThumb({
  src,
  alt,
  size = 'sm',
}: {
  src: string | null;
  alt: string;
  size?: 'sm' | 'full';
}) {
  const [errored, setErrored] = useState(false);
  const showImage = src && !errored;
  // 'sm' = fixed 64px thumbnail (search/list); 'full' = fill the parent box (product page).
  const sizeClass = size === 'full' ? 'w-full h-full' : 'w-16 h-16 shrink-0';

  if (showImage) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onError={() => setErrored(true)}
        className={`${sizeClass} object-contain bg-bg-subtle rounded`}
      />
    );
  }

  return (
    <div
      data-testid="product-thumb-placeholder"
      aria-hidden="true"
      className={`${sizeClass} rounded bg-bg-subtle border border-border-subtle/60 grid place-items-center`}
    >
      <Package size={size === 'full' ? 48 : 20} className="text-text-tertiary/70" />
    </div>
  );
}
